// Route lock for Hotel-Edition module pages (PLAN.md §2). The page renders only when the server's
// capability (`edition.modules`, lib/edition.ts) contains the module; otherwise → "/". While the capability
// loads: a neutral spinner, never a module page. On a load error: fail closed to "/".
import type { ReactNode } from "react";
import { Redirect } from "wouter";
import type { EditionModule } from "@shared/edition";
import { useEditionModule } from "@/lib/edition";

export function EditionModuleGate({ module, children }: { module: EditionModule; children: ReactNode }) {
  const access = useEditionModule(module);
  if (access === "loading") {
    return (
      <div className="min-h-[50vh] flex items-center justify-center" data-testid="edition-gate-loading">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (access === "denied") return <Redirect to="/" />;
  return <>{children}</>;
}

/** Old route that hands over to a module page once the module is live (e.g. /instagram-saeulen →
 *  /themenkatalog). Until the capability says so — loading, error, agency, module off — the old page
 *  renders exactly as before. */
export function EditionModuleRedirect({ module, to, children }: { module: EditionModule; to: string; children: ReactNode }) {
  const access = useEditionModule(module);
  if (access === "allowed") return <Redirect to={to} />;
  return <>{children}</>;
}
